import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false
    }

    componentDidMount () {
        Service.event.onFetchRevenueStatsBySource.add((chartData) => {
            this.setState({
                histogramChartCategoriesList: chartData.categoryList,
                histogramChartSeriesDataList: chartData.seriesDataList,
                renderChart : true
            });
        });

        Service.fetchRevenueStatsBySource(30);
    }

    componentWillUnmount() {

    }

    render() {

        const options = {
            title: {
                text: 'Revenue by Source for the last 30 days (top 20)'
            },
            xAxis: {
                categories: this.state.histogramChartCategoriesList
            },
            yAxis: {
                title: {
                    text: 'Revenue by source'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{point.x}</span><br>',
                pointFormat: '<span style="color:{point.color}">{series.name}: </span><b>${point.y}</b>'
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '${point.y:.2f}',
                    }
                }
            },
            series: [{
                name: 'Revenue last 30 days',
                type: 'column',
                colorByPoint: true,
                data: this.state.histogramChartSeriesDataList
            }]
        };

        return (
            <div className="graph-width">
                { this.state.renderChart ? <CustomChart options={options}/> : '' }
            </div>
        );
    }
}

export default ChartView;